import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen, ChevronDown, ChevronUp } from 'lucide-react';

interface Props {
  /** i18n key prefix, e.g. `forecastPage.guide` */
  i18nPrefix: string;
  className?: string;
}

export function DemandPlanningGuide({ i18nPrefix, className = '' }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const items = [0, 1, 2, 3].map((i) => t(`${i18nPrefix}.item${i}`, { defaultValue: '' })).filter(Boolean);

  if (items.length === 0) return null;

  return (
    <div
      className={`rounded-xl border border-sky-200 bg-gradient-to-br from-sky-50 to-white ${className}`}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left"
        onClick={() => setExpanded((v) => !v)}
      >
        <span className="flex items-center gap-2 text-sm font-medium text-sky-900">
          <BookOpen className="h-4 w-4 shrink-0" />
          {t(`${i18nPrefix}.title`)}
        </span>
        {expanded ? (
          <ChevronUp className="h-4 w-4 text-sky-600" />
        ) : (
          <ChevronDown className="h-4 w-4 text-sky-600" />
        )}
      </button>
      {expanded ? (
        <ul className="space-y-2 border-t border-sky-100 px-4 pb-4 pt-2 text-sm text-sky-900/90">
          {items.map((text) => (
            <li key={text} className="flex gap-2">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-sky-500" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
